export default "__VITE_ASSET__XqoicxaH__"